import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/collect";

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function exportExcel(criteria) {
  return request({
    url: prefix + '/export/excel',
    method: 'post',
    data: criteria,
    responseType: 'blob'
  })
}

export function downloadZip(criteria) {
  return request({
    url: prefix + '/download/zip',
    method: 'post',
    data: criteria,
  })
}

